export default {
  SIMPLE: 'SIMPLE', // 极简模式
  MEDIUM: 'MEDIUM', // 中等模式
  INTEGRITY: 'INTEGRITY' // 完成模式
};
